import React from "react";

export const Label = (props: React.PropsWithChildren<unknown>) => {
  return (
    <div className="flex gap-small align-center" style={{ borderRadius: 32, padding: 6, paddingLeft: 12, paddingRight: 12, backgroundColor: "var(--removable-label-bg)" }}>
      <div>{props.children}</div>
    </div>
  );
};